import { type IUseTranslation, useTranslation } from "@/hooks"
import ThreeDotsSvg from "@/svgs/ThreeDotsSvg"

import Button from "../button/Button"

type Props = {
    onClick?: () => void
}

const ThreeDotsMenu = ({ onClick }: Props) => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <Button variant="default" aria-label={t("common.ariaLabels.threeDotsButton")} className="p-2" onClick={onClick}>
            <ThreeDotsSvg />
        </Button>
    )
}
export default ThreeDotsMenu
